<h2 class="heading-lg">Start choosing dates</h2>

<div role="tablist" class="segmented-control">
  <label class="segment">
    <input
      #fixedDates
      class="segment-input"
      name="flow-type"
      [checked]="selectedFlow() === 'fixed'"
      (change)="selectedFlow.set('fixed')"
      [ariaSelected]="selectedFlow() === 'fixed'"
      type="radio"
      role="tab"
      aria-controls="fixed-dates" />
    <span id="fixed-label" class="label">Specific dates</span>
  </label>
  <label class="segment">
    <input
      #rangeDates
      name="flow-type"
      class="segment-input"
      [checked]="selectedFlow() === 'voting'"
      (change)="selectedFlow.set('voting')"
      [ariaSelected]="selectedFlow() === 'voting'"
      type="radio"
      role="tab"
      aria-controls="range-dates" />
    <span id="voting-label" class="label">
      Gather availability
    </span>
  </label>
</div>
<div
  id="fixed-dates"
  role="tabpanel"
  tabindex="0"
  aria-labelledby="fixed-label"
  [attr.hidden]="selectedFlow() === 'fixed' ? undefined : true">
  <at-fixed-dates-selector></at-fixed-dates-selector>
</div>
<div
  id="range-dates"
  role="tabpanel"
  tabindex="0"
  aria-labelledby="voting-label"
  [attr.hidden]="selectedFlow() === 'voting' ? undefined : true">
  <at-range-selector></at-range-selector>
</div>
